import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { TestModel } from 'app/EMR/PrimaryExaminationModels/test.model';
import { startWith, map, takeUntil } from 'rxjs/operators';
import { HelplistService } from 'app/helplist.service';
import { MatTableDataSource } from '@angular/material/table';
import { ExaminationHelpComponent } from 'app/EMR/ExaminationHelp/ExaminationHelp.component';
import { MatDialog } from '@angular/material/dialog';
import { EMRService } from 'app/EMR/EMR.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { FindingGroupdataModel } from 'app/EMR/DoctorModels/findingsubcategorydata.model';
import { FindingResultModel } from 'app/EMR/DoctorModels/findingResult.model';
import { I } from '@angular/cdk/keycodes';
import { TemplateFindingsComponent } from 'app/EMR/TemplateFindings/TemplateFindings.component';
import { AuthService } from 'app/auth/auth.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DatePipe } from '@angular/common';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-Opd_test',
  templateUrl: './Opd_test.component.html',
  styleUrls: ['./Opd_test.component.scss']
})
export class Opd_testComponent implements OnInit {
  destroyopdtest$: Subject<boolean> = new Subject<boolean>();
  private myControl = new FormControl();
  private filteredOptions: Observable<TestModel[]>;
  // private allow_test = true;
  private filterDate: Date;
  // private tests_ds: MatTableDataSource<any>
  private investigations_ds: MatTableDataSource<any>
  private Activetable: number;
  // private displayedColumns_tests: string[] = ['tests', 'eyesite', 'comments', 'Action'];
  // private displayedColumns_investigations: string[] = ['investigations', 'eyesite', 'Action'];
  private findinggroupdata: FindingGroupdataModel[] = [];
  private examTypeCtrl: FormControl;
  private examTypeCtrledit: FormControl;
  private filteredexamTypeArray: Observable<any[]>;
  private filteredexamTypeArrayedit: Observable<any[]>;
  private rightTypeCtrl: FormControl;
  private rightTypeCtrledit: FormControl;
  private filteredrightTypeArray: Observable<any[]>;
  private filteredrightTypeArrayedit: Observable<any[]>;
  private leftTypeCtrl: FormControl;
  private leftTypeCtrledit: FormControl;
  private filteredleftTypeArray: Observable<any[]>;
  private filteredleftTypeArrayedit: Observable<any[]>;
  private result_ds: FindingResultModel[] = [];
  private righteyeid: number;
  private lefteyeid: number;
  private leftTypeName: any;
  private findingid: number;
  private examTypeName: any;
  private resultArray: any = [];
  private rightTypeName: any;
  private enabledisablebtn: boolean = false;
  private result_dsa: any;
  private editCache: { [key: string]: any } = {};
  private findId: any;
  private visitIdprev: any;
  enableTransfer: boolean = false;
  rightEyeSingleCtrl = new FormControl(null);
  leftEyeSingleCtrl = new FormControl(null);
  newlistarrray: any[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild('rightEyeACTrigger') rightEyeTrigger: MatAutocompleteTrigger;
  @ViewChild('leftEyeACTrigger') leftEyeTrigger: MatAutocompleteTrigger;

  @ViewChild('rightEyeInput') rightEyeInput: ElementRef<HTMLInputElement>;
  @ViewChild('leftEyeInput') leftEyeInput: ElementRef<HTMLInputElement>;




  constructor(private helplistservice: HelplistService, private dialog: MatDialog, private emrservice: EMRService, private datePipe: DatePipe,
    private authService: AuthService, private opdvisitService: OpdVisitService, private dashboardService: DashboardService,) { }

  ngOnInit() {
    // this.get_visit_dates();
    this.findinggroupdata = [];
    this.result_ds = [];
    this.enabledisablebtn = true;

    this.emrservice.share.pipe(takeUntil(this.destroyopdtest$)).subscribe((x: any) => {
      if (x == 3) {
        this.getsplitlampDetail(this.emrservice.visitid, 0);
      }
    })
    this.emrservice.osleshare.pipe(takeUntil(this.destroyopdtest$)).subscribe((x: any) => {
      if (x == 'section17') {
        this.getsplitlampDetail(this.opdvisitService.visitid, 0);
        this.GetFindingGroupResult(0, 0);
      }
    })
    this.GetFindingGroupdata(0, 0, 0);

    this.ExamTypeControll();
    this.rightTypeControll();
    this.leftTypeControll();
    // this.getNormalFinding();

    this.updateEdit();
    this.ExamTypeControlledit();
    this.rightTypeControlledit();
    this.leftTypeControlledit();
    this.Activetable = 1;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => value ? this._filter(value) : this.helplistservice.tests.slice())
    );

  }

  ngOnDestroy() {
    this.destroyopdtest$.next(true);
    this.destroyopdtest$.unsubscribe();
    this.resultArray = null;
    this.editCache = null;
    this.result_ds = null
    this.findinggroupdata = null;
  }

  private _filter(value: string): TestModel[] {
    const filterValue = value.toLowerCase();
    return this.helplistservice.tests.filter(test => test.testName.toLowerCase().indexOf(filterValue) === 0);
  }

  // setbutton_enabled() {
  //   this.allow_test = false;
  // }




  //Add Opto Slit Lamp Modal
  addOptoSlitLamp() {
    if (this.emrservice.optoSliptLampPermission.isAddPermission == true) {
      document.getElementById("addOptoSlitLampModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
  }
  canceladdOptoSlitLamp() {
    this.examTypeName = null;
    this.leftTypeName = null;
    this.rightTypeName = null;
    this.findingid = 0;
    this.lefteyeid = 0;
    this.righteyeid = 0;
    document.getElementById("addOptoSlitLampModal").style.display = "none";
  }

  changetable(type) {
    this.Activetable = type;
  }

  //Examination Help
  examinationHelpModal() {
    document.getElementById("examinationHelpModal").style.display = "block";
  }
  cancelexaminationHelpModal() {
    document.getElementById("examinationHelpModal").style.display = "none";
  }

  //Load Previous Visit Examination
  loadPreviousVisitExaminationModal() {
    this.get_visit_dates(1);

  }
  cancelloadPreviousVisitExaminationModal() {
    document.getElementById("loadPreviousVisitExaminationModal").style.display = "none";
  }
  GetFindingGroupdata(fk_subGroupId, type, searchtype) {
    this.emrservice.GetFindingGroupdata(fk_subGroupId, type, searchtype).pipe(takeUntil(this.destroyopdtest$)).subscribe(
      data => this.success_FindingSubdata(data), err => this.failed_FindingSubGroup(err)
    )
  }
  success_FindingSubdata(data) {
    this.findinggroupdata = data;
    this.ExamTypeControll();
    this.ExamTypeControlledit();
  }
  GetFindingGroupResult(type, seachtype) {
    this.emrservice.GetFindingGResult(0, type, seachtype).pipe(takeUntil(this.destroyopdtest$)).subscribe(
      data => this.success_Findingreult(data), err => this.failed_FindingSubGroup(err)
    )
  }
  success_Findingreult(data) {
    this.resultArray = [];
    if (data.length > 0) {
      this.resultArray = data;
      this.result_ds = data;
      this.rightTypeControll();
      this.leftTypeControll();
    }
  }
  failed_FindingSubGroup(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  getNormalFinding() {
    this.emrservice.GetNormalFindingTemplate(1).pipe(takeUntil(this.destroyopdtest$)).subscribe((x: any) => {
      if (x.length > 0) {
        this.enabledisablebtn = false;
        x.forEach(element => {
          this.newlistarrray.push({
            pK_TranId: 0,
            fK_VisitId: this.emrservice.visitid,
            fk_FindingId: element.fK_FindingId,
            pk_SynchId: 0,
            findingName: element.findingName,
            examValues1: element.result1,
            examValues2: element.result2,
            specification: element.findingName,
            findingSubGroup: element.findingSubGroup,
            isDelete: false,
            isEdit: false
          });
        });
        this.newlistarrray = this.newlistarrray.reduce((unique, o) => {
          if (!unique.some(obj => obj.findingName === o.findingName && obj.fk_FindingId === o.fk_FindingId)) {
            unique.push(o);
          }
          return unique;
        }, []);
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  //auto complete exam
  getexamTypeobj(e: any) {
    var val = e.option.value;
    this.examTypeName = val.findingName;
    this.findingid = val.pk_FindingId;
    if (this.findingid > 0) {
      this.result_ds = this.resultArray.filter(item => item.fk_FindingId == this.findingid);
      this.rightTypeControll();
      this.leftTypeControll();
    }
  }

  getexamTypeobjedit(e: any, index) {
    this.editCache[this.findId].data.findingName = e.option.value;
    this.editCache[this.findId].data.fk_FindingId = e.option.id;
    this.newlistarrray[index].findingName = e.option.value;
    this.newlistarrray[index].fk_FindingId = e.option.id;
    this.editCache[index].data.examValues1 = '';
    this.editCache[index].data.examValues2 = '';
    this.newlistarrray[index].examValues1 = '';
    this.newlistarrray[index].examValues2 = '';
    this.editCache[index].data.rightEyeArray = [];
    this.editCache[index].data.leftEyeArray = [];
    this.editCache[index].data.rightEyeCtrl.setValue('');
    this.editCache[index].data.leftEyeCtrl.setValue('');


    if (e.option.id > 0) {
      this.result_ds = this.resultArray.filter(item => item.fk_FindingId == e.option.id);
      this.rightTypeControlledit();
      this.leftTypeControlledit();
    }
  }
  CheckinputexamType(event: any) {
    //  this.examTypeName=null;
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.ExamTypeControll();
      //  this.opTypeId = 0;
      this.findingid = 0;
      this.examTypeName = null;
    }
  }
  rightTypeControll() {
    this.rightTypeCtrl = new FormControl();
    this.filteredrightTypeArray = this.rightTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterrightfunction(cat) : this.result_ds.slice())
      );

  }
  rightTypeControlledit() {
    this.rightTypeCtrledit = new FormControl();
    this.filteredrightTypeArrayedit = this.rightTypeCtrledit.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterrightfunction(cat) : this.result_ds.slice())
      );

  }
  filterrightfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.result_ds.filter(country =>
      country.result?.toLowerCase().indexOf(filterValue) === 0);

  }
  CheckinputleftType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.leftTypeControll();
      //  this.opTypeId = 0;
      this.lefteyeid = 0;
      this.leftTypeName = null;
    }
  }

  leftTypeControll() {
    this.leftTypeCtrl = new FormControl();
    this.filteredleftTypeArray = this.leftTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterleftfunction(cat) : this.result_ds.slice())
      );

  }
  leftTypeControlledit() {
    this.leftTypeCtrledit = new FormControl();
    this.filteredleftTypeArrayedit = this.leftTypeCtrledit.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterleftfunction(cat) : this.result_ds.slice())
      );

  }
  filterleftfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.result_ds.filter(country =>
      country.result?.toLowerCase().indexOf(filterValue) === 0);

  }

  ExamTypeControll() {

    this.examTypeCtrl = new FormControl();
    this.filteredexamTypeArray = this.examTypeCtrl.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterOpfunction(cat) : this.findinggroupdata.slice())
      );

  }
  ExamTypeControlledit() {

    this.examTypeCtrledit = new FormControl();
    this.filteredexamTypeArrayedit = this.examTypeCtrledit.valueChanges
      .pipe(
        startWith(''),
        map(cat => cat ? this.filterOpfunction(cat) : this.findinggroupdata.slice())
      );

  }
  filterOpfunction(name: string) {
    const filterValue = name.toString().toLowerCase();
    return this.findinggroupdata.filter(country =>
      country.findingName?.toLowerCase().indexOf(filterValue) === 0);


  }
  getrightTypeobj(e: any) {

    var val = e.option.value;
    this.righteyeid = val.pK_TranId;
    this.rightTypeName = val.result;

  }
  getrightTypeobjedit(e: any) {

    this.editCache[this.findId].data.examValues1 = e.option.value;
    this.newlistarrray[this.findId].examValues1 = e.option.value;


  }
  CheckinputrightType(event: any) {
    var checkdata = event.target.value;
    if (checkdata == "") {
      this.rightTypeControll();
      this.righteyeid = 0;
      this.rightTypeName = null;
    }
  }
  // autocomplete left eye
  getleftTypeobj(e: any) {
    var val = e.option.value;
    this.leftTypeName = val.result;
    this.lefteyeid = val.pK_TranId;
  }

  getleftTypeobjedit(e: any) {

    this.editCache[this.findId].data.examValues2 = e.option.value;
    this.newlistarrray[this.findId].examValues2 = e.option.value;
  }
  //newlistarrray: any = [];

  // addExamlist() {


  //   // this.findings_ds.data = [];
  //   if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {

  //     if (this.examTypeName != null && this.leftTypeName != null && this.rightTypeName != null && this.findingid != undefined && this.findingid != 0 && this.lefteyeid != 0 && this.righteyeid != 0) {
  //       let checkfinding = this.newlistarrray.filter(item => item.fk_FindingId == this.findingid);
  //       if (checkfinding.length == 0) {
  //         this.enabledisablebtn = false;
  //         this.newlistarrray.push({
  //           pK_TranId: 0,
  //           fK_VisitId: this.emrservice.visitid,
  //           fk_FindingId: this.findingid,
  //           pk_SynchId: 0,
  //           findingName: this.examTypeName,
  //           examValues1: this.rightTypeName,
  //           examValues2: this.leftTypeName,
  //           specification: this.examTypeName,
  //           findingSubGroup: null,
  //           isDelete: false,
  //           isEdit: false
  //         });
  //         this.updateEdit();
  //       } else {
  //         this.dashboardService.openSnackBar("This Record Aleady Exists", "OK");
  //         return;
  //       }

  //       this.canceladdOptoSlitLamp();
  //     } else {
  //       this.dashboardService.openSnackBar("Please Select All Field", "OK");
  //     }
  //   } else {
  //     this.dashboardService.openSnackBar("Please Select Visit List First", "OK");
  //   }
  // }

  // addExamlist() {
  //   // Make sure you have the examType, the selected right items, and the selected left items
  //   const selectedRight = this.rightTypeMultiCtrl.value || [];
  //   const selectedLeft  = this.leftTypeMultiCtrl.value  || [];

  //   if (!this.examTypeName || !this.findingid) {
  //     // Must pick an exam type
  //     this.dashboardService.openSnackBar("Please select Examination (Finding) first", "OK");
  //     return;
  //   }
  //   if (!selectedRight.length || !selectedLeft.length) {
  //     // Must pick at least one item for Right AND one for Left
  //     this.dashboardService.openSnackBar("Please select multiple results for both Right & Left Eye", "OK");
  //     return;
  //   }
  //   if (!this.emrservice.visitid) {
  //     this.dashboardService.openSnackBar("Visit ID not found. Please select a Visit first.", "OK");
  //     return;
  //   }

  //   // Now push a new row for EVERY combination of right + left
  //   // If your logic is different, adapt accordingly
  //   let addedCount = 0;

  //   for (const rightVal of selectedRight) {
  //     for (const leftVal of selectedLeft) {
  //       // Check if we already have that combination (finding + right + left)
  //       // to avoid duplicates in newlistarrray
  //       const found = this.newlistarrray.some(item =>
  //         item.fk_FindingId === this.findingid &&
  //         item.examValues1 === rightVal.result &&
  //         item.examValues2 === leftVal.result
  //       );
  //       if (!found) {
  //         this.newlistarrray.push({
  //           pK_TranId: 0,
  //           fK_VisitId: this.emrservice.visitid,
  //           fk_FindingId: this.findingid,
  //           pk_SynchId: 0,
  //           findingName: this.examTypeName,
  //           examValues1: rightVal.result, // Right Eye
  //           examValues2: leftVal.result,  // Left Eye
  //           specification: this.examTypeName,
  //           findingSubGroup: null,
  //           isDelete: false,
  //           isEdit: false
  //         });
  //         addedCount++;
  //       }
  //     }
  //   }

  //   if (addedCount === 0) {
  //     this.dashboardService.openSnackBar("All selected entries already exist", "OK");
  //   } else {
  //     this.dashboardService.openSnackBar(Added ${addedCount} new items, "OK");
  //   }

  //   // (Optionally) clear the multi-select controls after adding
  //   this.rightTypeMultiCtrl.setValue([]);
  //   this.leftTypeMultiCtrl.setValue([]);

  //   // Hide the modal
  //   this.canceladdOptoSlitLamp();
  // }

  addExamlist() {
    const selectedRight = this.rightEyeSingleCtrl.value;
    const selectedLeft = this.leftEyeSingleCtrl.value;

    if (!this.examTypeName || !this.findingid) {
      this.dashboardService.openSnackBar("Please select Examination (Finding) first", "OK");
      return;
    }
    if (!selectedRight || !selectedLeft) {
      this.dashboardService.openSnackBar("Please select Right & Left Eye results", "OK");
      return;
    }
    if (!this.emrservice.visitid) {
      this.dashboardService.openSnackBar("Visit ID not found. Please select a Visit first.", "OK");
      return;
    }

    const rightVal = selectedRight.result;
    const leftVal = selectedLeft.result;

    const foundRow = this.newlistarrray.find(item =>
      item.fk_FindingId === this.findingid &&
      item.examValues1 === rightVal &&
      item.examValues2 === leftVal
    );
    if (foundRow) {
      this.dashboardService.openSnackBar("This Record Already Exists", "OK");
      return;
    }

    this.newlistarrray.push({
      pK_TranId: 0,
      fK_VisitId: this.emrservice.visitid,
      fk_FindingId: this.findingid,
      pk_SynchId: 0,
      findingName: this.examTypeName,
      examValues1: rightVal,
      examValues2: leftVal,
      specification: this.examTypeName,
      findingSubGroup: null,
      isDelete: false,
      isEdit: false
    });

    this.rightEyeSingleCtrl.setValue(null);
    this.leftEyeSingleCtrl.setValue(null);

    this.updateEdit();
    this.canceladdOptoSlitLamp();
    this.dashboardService.openSnackBar("Added Successfully", "OK");
    this.enabledisablebtn = false;
  }


  getsplitlampDetail(visitid, type) {

    this.emrservice.GetOpdVisitFinding(visitid).pipe(takeUntil(this.destroyopdtest$)).subscribe((x: any) => {
      if (type == 0) {
        this.newlistarrray = [];
        this.newlistarrray = x.reverse();
        for (var i = 0; i < this.newlistarrray.length; i++) {
          this.newlistarrray[i].isEdit = false;
        }
        this.updateEdit();
      } else {
        this.newlistarrray = [];
        this.newlistarrray = x.reverse();
        for (var i = 0; i < this.newlistarrray.length; i++) {
          this.newlistarrray[i].isEdit = false;
          this.newlistarrray[i].pK_TranId = 0;
          this.newlistarrray[i].fK_VisitId = this.emrservice.visitid;
        }
        this.updateEdit();
      }

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  openexamination(): void {
    if (this.emrservice.optoSliptLampPermission.isAddPermission == true) {
      if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
        const dialogRef = this.dialog.open(ExaminationHelpComponent, {
          panelClass: 'full-width-dialog',
          maxWidth: '90vw',
          width: '90%'
        });

        dialogRef.afterClosed().pipe(takeUntil(this.destroyopdtest$)).subscribe(result => {
          if (result.length > 0) {
            this.enabledisablebtn = false;
            this.canceladdOptoSlitLamp();
            result?.forEach(item => {
              this.newlistarrray.push({
                pK_TranId: 0,
                fK_VisitId: this.emrservice.visitid,
                fk_FindingId: item.fk_FindingId,
                pK_SynchId: item.pk_SynchId,
                findingName: item.findingName,
                examValues1: item.examValues1,
                examValues2: item.examValues2,
                specification: item.findingName,
                findingSubGroup: null,
                isDelete: false,
                isEdit: false
              });
            });
            this.newlistarrray = this.newlistarrray.reduce((unique, o) => {
              if (!unique.some(obj => obj.findingName === o.findingName && obj.fk_FindingId === o.fk_FindingId)) {
                unique.push(o);
              }
              return unique;
            }, []);

          }
        });

      }
      else {
        this.dashboardService.openSnackBar("Please Select Visit List", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("You Don't have permission", "OK");
    }
  }
  opentemplates(): void {
    const dialogRef = this.dialog.open(TemplateFindingsComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '80vw',
      width: '70%',
      disableClose: true
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyopdtest$)).subscribe(result => {
      if (result?.length > 0) {
        this.enabledisablebtn = false;
        result?.forEach(element => {
          this.newlistarrray.push({
            pK_TranId: 0,
            fK_VisitId: this.emrservice.visitid,
            fk_FindingId: element.fK_FindingId,
            pk_SynchId: 0,
            findingName: element.findingName,
            examValues1: element.result1,
            examValues2: element.result2,
            specification: element.findingName,
            findingSubGroup: element.findingSubGroup,
            isAllowBlank:element.isAllowBlank,
            isDelete: false,
            isEdit: false
          });

        });
        this.newlistarrray = this.newlistarrray.reduce((unique, o) => {
          if (!unique.some(obj => obj.findingName === o.findingName && obj.fk_FindingId === o.fk_FindingId)) {
            unique.push(o);
          }
          return unique;
        }, []);
        // this.findings_ds = new MatTableDataSource(this.newlistarrray.slice());
      }
    });
  }
  removeRow(row: Object) {
    if (this.emrservice.optoSliptLampPermission.isDeletePermission == true) {
      const index: number = this.newlistarrray.indexOf(row);
      if (index !== -1) {
        this.newlistarrray.splice(index, 1);
        if (row['pK_TranId'] > 0) {
          this.deletesplitlaprecord(row);
        }
      }
    } else {
      this.dashboardService.openSnackBar("You Don't have permission", "OK");
    }
  }

  deletesplitlaprecord(obj: any) {
    if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
      this.emrservice.open_loader_Dialog();
      let payloadArray = [];
      payloadArray.push({
        "PK_TranId": obj.pK_TranId,
        "FK_VisitId": obj.fK_VisitId,
        "Fk_FindingId": obj.fk_FindingId,
        "ExamValues1": obj.examValues1,
        "ExamValues2": obj.examValues2,
        "Specification": obj.specification,
        "PK_SynchId": 0,
        "IsEdit": true,
        "IsDelete": true,
      })

      let payload = {
        "OpdVisitFindingDetail": payloadArray
      }
      if (this.emrservice.optoSliptLampPermission.isDeletePermission == true) {
        this.emrservice.InsertupdatedeletesplitLamp(payload).pipe(takeUntil(this.destroyopdtest$)).subscribe((x: any) => {
          this.dialog.closeAll();
          if (x['statusCode'] == 7 || x['statusCode'] == 9) {
            this.dashboardService.openSnackBar("Api Failed", "OK");
          } else {
            this.getsplitlampDetail(this.emrservice.visitid, 0);
            this.emrservice.getPExamStatus();
            this.dashboardService.openSnackBar("Record Delete Successfully", "OK");
          }
        }, err => {
          this.dialog.closeAll();
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.dashboardService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        })
      } else {
        this.dashboardService.openSnackBar("Delete Permission Denied", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Visit ID Not Found", "OK");
    }
  }
  insertUpdateSlpitlamp() {
    if (this.emrservice.visitid != null && this.emrservice.visitid != undefined) {
      this.emrservice.open_loader_Dialog();
      let payloadArray = [];
      if (this.newlistarrray.length > 0) {
        this.newlistarrray.forEach(item => {
          const isBlankAllowed = item.isAllowBlank === true;
          const isExamValue1Empty = item.examValues1 == null || item.examValues1 === '';
          const isExamValue2Empty = item.examValues2 == null || item.examValues2 === '';

          if (isBlankAllowed && isExamValue1Empty && isExamValue2Empty) {
            return;
          }


          payloadArray.push({
            "PK_TranId": item.pK_TranId > 0 ? item.pK_TranId : 0,
            "FK_VisitId": item.fK_VisitId,
            "Fk_FindingId": item.fk_FindingId,
            "ExamValues1": item.examValues1,
            "ExamValues2": item.examValues2,
            "Specification": item.specification,
            "PK_SynchId": 0,
            "IsEdit": item.pK_TranId > 0 ? true : false,
            "IsDelete": false,
          })
        })
      }
      let payload = {
        "OpdVisitFindingDetail": payloadArray
      }
      this.emrservice.InsertupdatedeletesplitLamp(payload).pipe(takeUntil(this.destroyopdtest$)).subscribe((x: any) => {
        this.dialog.closeAll();
        this.enabledisablebtn = true;
        if (x['statusCode'] == 7 || x['statusCode'] == 9) {
          this.dashboardService.openSnackBar("Api Failed", "OK");
        } else if (x['statusCode'] == 10) {
          this.dashboardService.openSnackBar("Alreday exists in the list", "OK");
          this.getsplitlampDetail(this.emrservice.visitid, 0);
        } else {
          this.getsplitlampDetail(this.emrservice.visitid, 0);
          this.emrservice.getPExamStatus();
          this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
        }
      }, err => {
        this.enabledisablebtn = false;
        this.dialog.closeAll();
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    } else {
      this.dashboardService.openSnackBar("Visit ID Not Found", "OK");
    }
  }
  // onfindingchange(e: any, index: number) {
  //   if (e != null) {
  //         
  //     let findingid = this.findinggroupdata.filter(item => item.findingName == e);
  //     this.newlistarrray[index].fk_FindingId = findingid[0].pk_FindingId;      
  //     this.newlistarrray[index].findingName = e;

  //   }
  // } onrightEyechange(e: any, index: number) {
  //   if (e != null) {

  //     this.newlistarrray[index].examValues1 = e;

  //   }
  // }
  // onleftEyechange(e: any, index: number) {
  //   if (e != null) {
  //         

  //     this.newlistarrray[index].examValues2 = e;

  //   }
  // }
  // Editdata(index:number){
  //       
  //   this.enabledisablebtn =false;
  //   this.newlistarrray.isEdit = false;
  //   this.newlistarrray[index].isEdit = true; 

  // }
  // saveEdit(index:number){
  //   this.newlistarrray[index].isEdit = false;
  // }

  // updateEdit(): void {

  //   this.newlistarrray.forEach((item, index) => {
  //     const id = index;
  //     this.editCache[id] = {
  //       edit: false,
  //       data: { ...item }
  //     };
  //   });

  // }

  updateEdit(): void {
    this.newlistarrray.forEach((item, index) => {
      const rightEyeArray = (item.examValues1 || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

      const leftEyeArray = (item.examValues2 || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);

      const rightEyeCtrl = new FormControl();
      const leftEyeCtrl = new FormControl();

      const filteredRightOptions: Observable<any[]> = rightEyeCtrl.valueChanges.pipe(
        startWith(null),
        map((typedValue: string | null) => {
          if (!typedValue) {
            return this.result_ds;
          }
          const filterValue = typedValue.toLowerCase();
          return this.result_ds.filter(opt => opt.result?.toLowerCase().includes(filterValue));
        })
      );

      const filteredLeftOptions: Observable<any[]> = leftEyeCtrl.valueChanges.pipe(
        startWith(null),
        map((typedValue: string | null) => {
          if (!typedValue) {
            return this.result_ds;
          }
          const filterValue = typedValue.toLowerCase();
          return this.result_ds.filter(opt => opt.result?.toLowerCase().includes(filterValue));
        })
      );

      this.editCache[index] = {
        edit: false,

        originalData: { ...item },

        data: {
          ...item,
          rightEyeArray,
          leftEyeArray,
          rightEyeCtrl,
          leftEyeCtrl,
          filteredRightOptions,
          filteredLeftOptions
        }
      };

    });
  }

  onRightChipAdd(event: any, rowIndex: number): void {
    if (this.rightEyeTrigger && this.rightEyeTrigger.panelOpen) {
      return;
    }
    const inputValue = (event.value || '').trim();
    if (!inputValue) {
      return;
    }
    const rightArray = this.editCache[rowIndex].data.rightEyeArray;
    if (!rightArray.includes(inputValue)) {
      rightArray.push(inputValue);
    }

    event.input.value = '';
    this.editCache[rowIndex].data.rightEyeCtrl.setValue(null);

    this.newlistarrray[rowIndex].examValues1 = rightArray.join(', ');
  }


  onRightSelect(event: MatAutocompleteSelectedEvent, rowIndex: number): void {
    const newVal = event.option.value || '';
    const rightArray = this.editCache[rowIndex].data.rightEyeArray;
    if (rightArray.includes(newVal)) {
      rightArray.splice(rightArray.indexOf(newVal), 1);
    } else {
      rightArray.push(newVal);
    }
    this.editCache[rowIndex].data.rightEyeCtrl.setValue('');
    if (this.rightEyeInput) {
      this.rightEyeInput.nativeElement.value = '';
    }
    this.newlistarrray[rowIndex].examValues1 = rightArray.join(', ');

    requestAnimationFrame(() => {
      this.openAuto(this.rightEyeTrigger);
    });
  }

  onRemoveRightChip(rowIndex: number, chipIndex: number): void {
    const rightArray = this.editCache[rowIndex].data.rightEyeArray;
    rightArray.splice(chipIndex, 1);

    this.newlistarrray[rowIndex].examValues1 = rightArray.join(', ');
  }

  onLeftChipAdd(event: any, rowIndex: number): void {
    if (this.leftEyeTrigger && this.leftEyeTrigger.panelOpen) {
      return;
    }
    const inputValue = (event.value || '').trim();
    if (!inputValue) {
      return;
    }

    const leftArray = this.editCache[rowIndex].data.leftEyeArray;
    if (!leftArray.includes(inputValue)) {
      leftArray.push(inputValue);
    }

    event.input.value = '';
    this.editCache[rowIndex].data.leftEyeCtrl.setValue(null);
    this.newlistarrray[rowIndex].examValues2 = leftArray.join(', ');
  }

  onLeftSelect(event: MatAutocompleteSelectedEvent, rowIndex: number): void {
    const newVal = event.option.value || '';
    const leftArray = this.editCache[rowIndex].data.leftEyeArray;
    if (leftArray.includes(newVal)) {
      leftArray.splice(leftArray.indexOf(newVal), 1);
    } else {
      leftArray.push(newVal);
    }

    this.editCache[rowIndex].data.leftEyeCtrl.setValue('');
    if (this.leftEyeInput) {
      this.leftEyeInput.nativeElement.value = '';
    }

    this.newlistarrray[rowIndex].examValues2 = leftArray.join(', ');

    requestAnimationFrame(() => {
      this.openAuto(this.leftEyeTrigger);
    });
  }

  onRemoveLeftChip(rowIndex: number, chipIndex: number): void {
    const leftArray = this.editCache[rowIndex].data.leftEyeArray;
    leftArray.splice(chipIndex, 1);
    this.newlistarrray[rowIndex].examValues2 = leftArray.join(', ');
  }


  openAuto(trigger: MatAutocompleteTrigger) {
    if (trigger) {
      trigger.openPanel();
    }
  }


  Edit(index, element) {
    if (this.emrservice.pasthistoryPermission?.isModifyPermission == true) {
      const id = index;
      let find_Id = element.fk_FindingId;
      this.result_ds = this.resultArray.filter(item => item.fk_FindingId == find_Id);
      this.rightTypeControlledit();
      this.leftTypeControlledit();
      this.findId = id;
      this.updateEdit();
      this.editCache[id].edit = true;
      this.newlistarrray[index].isEdit = true;
      this.enabledisablebtn = false;

    } else {
      this.dashboardService.openSnackBar("Modify permission denied", "OK");
    }
  }

  editfindingdata: any = [];
  // saveEdit(idx): void {
  //   const id = idx;
  //   let payloadarray = [];
  //   //  let editpayload;
  //   let editlist = this.editCache[id].data;
  //   if (editlist.examValues1 != null && editlist.examValues1 != "" || editlist.examValues2 != null && editlist.examValues2 != "") {
  //     this.newlistarrray[idx].pK_TranId = editlist.pK_TranId ? editlist.pK_TranId : 0;
  //     this.newlistarrray[idx].fK_VisitId = editlist.fK_VisitId;
  //     this.newlistarrray[idx].fk_FindingId = editlist.fk_FindingId;
  //     this.newlistarrray[idx].examValues1 = editlist.examValues1;
  //     this.newlistarrray[idx].examValues2 = editlist.examValues2;
  //     this.newlistarrray[idx].specification = editlist.specification;
  //     this.newlistarrray[idx].IsEdit = editlist.pK_TranId != 0 ? true : false;
  //     this.newlistarrray[idx].IsDelete = false;
  //     this.newlistarrray.forEach(item => {
  //     payloadarray.push({
  //       "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
  //       "FK_VisitId": item.fK_VisitId,
  //       "Fk_FindingId": item.fk_FindingId,
  //       "ExamValues1": item.examValues1,
  //       "ExamValues2": item.examValues2,
  //       "Specification": item.findingName, // change finding name specifiction to findingName
  //       "PK_SynchId": 0,
  //       "IsEdit": item.pK_TranId > 0 ? true : false,
  //       "IsDelete": false,
  //     })
  //   });


  //     this.editCache[id].edit = false;
  //     this.enabledisablebtn = false;
  //     let payload = {
  //       "OpdVisitFindingDetail": payloadarray
  //     }
  //     this.emrservice.InsertupdatedeletesplitLamp(payload).subscribe((x: any) => {
  //       this.dialog.closeAll();
  //       this.enabledisablebtn = true;
  //       if (x['statusCode'] == 7 || x['statusCode'] == 9) {
  //         this.dashboardService.openSnackBar("Api Failed", "OK");
  //       } else if (x['statusCode'] == 10) {
  //         this.dashboardService.openSnackBar("Alreday exists in the list", "OK");
  //         this.getsplitlampDetail(this.emrservice.visitid, 0);
  //       } else {
  //         this.getsplitlampDetail(this.emrservice.visitid, 0);
  //         this.emrservice.getPExamStatus();
  //         this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
  //       }
  //     }, err => {
  //       this.enabledisablebtn = false;
  //       this.dialog.closeAll();
  //       this.dashboardService.openSnackBar("Api Failed", "OK");
  //     })
  //   } else {
  //     this.dashboardService.openSnackBar("Please Select All Field", "OK");
  //   }

  // }

  // saveEdit(idx: number): void {
  //   const id = idx;
  //   const payloadarray = [];
  //   const editlist = this.editCache[id].data;

  //   const rightString = (editlist.rightEyeArray || []).join(', ');
  //   const leftString  = (editlist.leftEyeArray || []).join(', ');

  //   if ((!rightString || rightString.trim() === '') && 
  //       (!leftString || leftString.trim() === '')) {
  //     this.dashboardService.openSnackBar("Please select values for Right / Left Eye", "OK");
  //     return;
  //   }

  //   this.newlistarrray[idx].pK_TranId   = editlist.pK_TranId ? editlist.pK_TranId : 0;
  //   this.newlistarrray[idx].fK_VisitId  = editlist.fK_VisitId;
  //   this.newlistarrray[idx].fk_FindingId= editlist.fk_FindingId;
  //   this.newlistarrray[idx].examValues1 = rightString;
  //   this.newlistarrray[idx].examValues2 = leftString;
  //   this.newlistarrray[idx].specification = editlist.specification;
  //   this.newlistarrray[idx].IsEdit      = editlist.pK_TranId != 0 ? true : false;
  //   this.newlistarrray[idx].IsDelete    = false;

  //   this.newlistarrray.forEach(item => {
  //     payloadarray.push({
  //       "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
  //       "FK_VisitId": item.fK_VisitId,
  //       "Fk_FindingId": item.fk_FindingId,
  //       "ExamValues1": item.examValues1,
  //       "ExamValues2": item.examValues2,
  //       "Specification": item.findingName,
  //       "PK_SynchId": 0,
  //       "IsEdit": item.pK_TranId > 0 ? true : false,
  //       "IsDelete": false,
  //     });
  //   });

  //   this.editCache[id].edit = false;
  //   this.enabledisablebtn   = false;

  //   const payload = {
  //     "OpdVisitFindingDetail": payloadarray
  //   };

  //   this.emrservice.InsertupdatedeletesplitLamp(payload).subscribe((x: any) => {
  //       this.dialog.closeAll();
  //       this.enabledisablebtn = true;
  //       if (x['statusCode'] == 7 || x['statusCode'] == 9) {
  //         this.dashboardService.openSnackBar("Api Failed", "OK");
  //       } else if (x['statusCode'] == 10) {
  //         this.dashboardService.openSnackBar("Already exists in the list", "OK");
  //         this.getsplitlampDetail(this.emrservice.visitid, 0);
  //       } else {
  //         this.getsplitlampDetail(this.emrservice.visitid, 0);
  //         this.emrservice.getPExamStatus();
  //         this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
  //       }
  //     },
  //     err => {
  //       this.enabledisablebtn = false;
  //       this.dialog.closeAll();
  //       this.dashboardService.openSnackBar("Api Failed", "OK");
  //     }
  //   );
  // }

  saveEdit(_clickedIndex: number): void {
    const rowsInEdit: number[] = this.newlistarrray
      .map((row, i) => ({ row, i }))
      .filter(({ row }) => row.isEdit === true)
      .map(({ i }) => i);

    if (rowsInEdit.length === 0) {
      return;
    }

    const payloadArray = [];
    for (const rowIndex of rowsInEdit) {
      const editlist = this.editCache[rowIndex].data;

      const rightString = (editlist.rightEyeArray || []).join(', ');
      const leftString = (editlist.leftEyeArray || []).join(', ');

      this.newlistarrray[rowIndex].examValues1 = rightString;
      this.newlistarrray[rowIndex].examValues2 = leftString;

      this.newlistarrray[rowIndex].isEdit = false;
      this.editCache[rowIndex].edit = false;

      this.editCache[rowIndex].originalData = {
        ...this.newlistarrray[rowIndex]
      };
      // payloadArray.push({
      //   PK_TranId: this.newlistarrray[rowIndex].pK_TranId || 0,
      //   FK_VisitId: this.newlistarrray[rowIndex].fK_VisitId,
      //   Fk_FindingId: this.newlistarrray[rowIndex].fk_FindingId,
      //   ExamValues1: rightString,
      //   ExamValues2: leftString,
      //   Specification: this.newlistarrray[rowIndex].findingName,
      //   PK_SynchId: 0,
      //   IsEdit: this.newlistarrray[rowIndex].pK_TranId > 0,
      //   IsDelete: false,
      // });
    }
    if (this.newlistarrray.length > 0) {
      this.newlistarrray.forEach(item => {
         const isBlankAllowed = item.isAllowBlank === true;
          const isExamValue1Empty = item.examValues1 == null || item.examValues1 === '';
          const isExamValue2Empty = item.examValues2 == null || item.examValues2 === '';

          if (isBlankAllowed && isExamValue1Empty && isExamValue2Empty) {
            return;
          }
        payloadArray.push({
          "PK_TranId": item.pK_TranId > 0 ? item.pK_TranId : 0,
          "FK_VisitId": item.fK_VisitId,
          "Fk_FindingId": item.fk_FindingId,
          "ExamValues1": item.examValues1,
          "ExamValues2": item.examValues2,
          "Specification": item.specification,
          "PK_SynchId": 0,
          "IsEdit": item.pK_TranId > 0 ? true : false,
          "IsDelete": false,
        })
      })
    }
    const payload = { "OpdVisitFindingDetail": payloadArray };

    this.emrservice.InsertupdatedeletesplitLamp(payload).subscribe(
      (x: any) => {
        if(x.statusCode == 10){
        this.dashboardService.openSnackBar("Record Already Exists", "OK");
            this.getsplitlampDetail(this.emrservice.visitid, 0);
        }else{
          this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
            this.getsplitlampDetail(this.emrservice.visitid, 0);
          this.emrservice.getPExamStatus();
          this.enabledisablebtn = true;
        }
      },err => {
         if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }
    );
  }

  // cancelEdit(idx): void {
  //   const id = idx;
  //   this.editCache[id].edit = false;
  // }

  cancelEdit(idx: number): void {
    const original = this.editCache[idx].originalData;
    this.newlistarrray[idx] = { ...original };
    this.editCache[idx].edit = false;
  }


  get_visit_dates(type: any) {

    this.emrservice.open_loader_Dialog();
    if (this.authService.masterdata.emrLevel == 3) {
      this.emrservice.getCareVisit(this.opdvisitService.visitid, this.opdvisitService.DoctorIdEmr).pipe(takeUntil(this.destroyopdtest$)).subscribe((x: any) => {
        this.opdvisitService.visitdates = x.sort((a, b) => {
          return <any>new Date(b.visitDate) - <any>new Date(a.visitDate) || <any>b.pK_ExamId - <any>a.pK_ExamId;
        });

        if (type == 1) {
          var myDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd')
          var todateDate = this.opdvisitService.visitdates.filter(item => item.visitDate.split('T')[0] == myDate);
          if (todateDate.length > 0) {
            if (todateDate[0].opId != null) {
              //  this.enableTransfer = true;
              // document.getElementById("loadPreviousVisitExaminationModal").style.display = "none";
              this.dashboardService.openSnackBar("In Modification Mode, Load Previous Data Not Allowed", "ok")
            } else {
              document.getElementById("loadPreviousVisitExaminationModal").style.display = "block";
            }
          }
        }

        this.dialog.closeAll();
      }, err => {
        this.dialog.closeAll();
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    } else {
      this.emrservice.getCareVisit(0, 0).pipe(takeUntil(this.destroyopdtest$)).subscribe((x: any) => {

        this.opdvisitService.visitdates = x.sort((a, b) => {
          return <any>new Date(b.visitDate) - <any>new Date(a.visitDate) || <any>b.pK_ExamId - <any>a.pK_ExamId;
        });

        if (type == 1) {
          var myDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd')
          var todateDate = this.opdvisitService.visitdates.filter(item => item.visitDate.split('T')[0] == myDate);
          if (todateDate.length > 0) {
            if (todateDate[0].opId != null) {
              // this.enableTransfer = true;
              // document.getElementById("loadPreviousVisitExaminationModal").style.display = "none";
              this.dashboardService.openSnackBar("In Modification Mode, Load Previous Data Not Allowed", "ok")
            } else {
              document.getElementById("loadPreviousVisitExaminationModal").style.display = "block";
            }
          }

        }
        this.dialog.closeAll();
      }, err => {
        this.dialog.closeAll();
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
    }


  }
  selectrow(row) {

    this.dashboardService.selectedRowIndex = row.fK_VisitId;
    this.visitIdprev = row.fK_VisitId;
  }
  getvisitdata(id: any) {

    this.enabledisablebtn = false;
    this.getsplitlampDetail(this.visitIdprev, 1);
    this.cancelloadPreviousVisitExaminationModal();
  }


}